<div class="dnd-list-headers">
  <div class="page-title">DND Email List</div>
  @if (dndEmails.length > 0) {
    <div class="page-size">
      <app-page-size
        [pageSize]="pageSize"
        [selectId]="'dnd-list'"
        (pageSizeChanged)="onPageSizeChange($event)"
      ></app-page-size>
    </div>
  }
</div>

<div class="filter-search-section">
  <div class="search-section-wrapper">
    <app-search-input
      [placeholder]="'Search Email ...'"
      [(searchQuery)]="searchQuery"
      (searchQueryChange)="onSearchQueryChange($event)"
    ></app-search-input>
  </div>
  <div class="add-email">
    <a href="javascript:void(0)" class="add-email-btn" (click)="onAddClick()">
      <app-svg-icon
        [iconName]="'add.svg'"
        [height]="'16px'"
        [width]="'16px'"
        [style.fill]="'#fff'"
      ></app-svg-icon>
      <span>Add Email</span>
    </a>
  </div>
</div>

<app-table [columns]="tableColumns" [data]="dndEmails" [loading]="loading">
  <ng-template let-dndEmail>
    <tr>
      <td>
        {{ dndEmail.email }}
      </td>
      <td>
        {{ dndEmail.reason || "—" }}
      </td>
      <td>
        {{
          dndEmail.created_at_utc
            ? (dndEmail.created_at_utc | date: "medium")
            : "—"
        }}
      </td>
      <td class="actions">
        <button
          class="delete-btn"
          (click)="openDeleteDndPopup(dndEmail)"
          title="Delete"
        >
          <app-svg-icon
            [iconName]="'delete.svg'"
            [height]="'14px'"
            [width]="'14px'"
            [style.fill]="'#64748b'"
          ></app-svg-icon>
        </button>
      </td>
    </tr>
  </ng-template>
</app-table>

@if (dndEmails.length > 0) {
  <app-pagination
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalItems]="totalDndEmails"
    (pageChanged)="onPageChange($event)"
  ></app-pagination>
}

@if (isDndPopupVisible) {
  <app-popup
    [heading]="'Add New DND Email'"
    [confirmText]="'Add'"
    [cancelText]="'Cancel'"
    [isConfirmDisabled]="!isDndFormValid"
    (confirmClicked)="onConfirmAddDndEmail()"
    (cancelClicked)="onCancelDndPopup()"
  >
    <div class="dnd-card">
      <div class="form-group">
        <label for="dnd-email" class="form-label">
          Email Address <span class="required">*</span>
        </label>
        <input
          id="dnd-email"
          type="email"
          placeholder="Enter email address"
          [(ngModel)]="newEmail"
          [class.error]="newEmail && !isValidEmail(newEmail)"
        />
        @if (newEmail && !isValidEmail(newEmail)) {
          <p class="error-text">Please enter a valid email address</p>
        }
      </div>

      <div class="form-group">
        <label for="dnd-reason" class="form-label">
          Reason <span class="required">*</span>
        </label>
        <textarea
          id="dnd-reason"
          placeholder="Enter reason for blocking"
          [(ngModel)]="newReason"
          [class.error]="isReasonOnlyNumbers(newReason)"
          rows="3"
        ></textarea>
        @if (isReasonOnlyNumbers(newReason)) {
          <p class="error-text">Reason cannot contain only numbers</p>
        }
      </div>
    </div>
  </app-popup>
}

@if (showDeleteDndConfirmPopup) {
  <app-popup
    [heading]="'Confirm Delete'"
    [confirmText]="'Delete'"
    [cancelText]="'Cancel'"
    (confirmClicked)="confirmDeleteDndEmail()"
    (cancelClicked)="closeDeleteDndPopup()"
  >
    Are you sure you want to delete the DND email
    <b>{{ selectedDndEmail?.email }}</b
    >?
  </app-popup>
}
